import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import { ParticipantsEventSettingsState } from './ParticipantsEventSettings.state';
import { Popup } from 'src/components/Popup/Popup';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

export interface ParticipantsEventSettingsType {
    eventId: EventId;
    onSetErrorMessage: (message: string) => void;
}

export const ParticipantsEventSettings = observer(
    'ParticipantsEventSettings',
    (props: ParticipantsEventSettingsType) => {
        const { eventStateActions, sdkStaff } = useAppStateContext();
        const [participantsEventSettingsState] = useState(
            () => new ParticipantsEventSettingsState(() => props, sdkStaff, eventStateActions)
        );
        const { currentParticipantsList, setIsEditMode, isEditMode, setFilter } = participantsEventSettingsState;

        return (
            <div>
                <section className='event-details-box last'>
                    <h4>Participants</h4>
                    <ul className='event-details-participants'>
                        {currentParticipantsList.map(({ id, name, role }) => (
                            <li key={id}>
                                <span className='event-details-participants__role'>{role}</span>
                                {name === '' ? 'n/a' : name}
                            </li>
                        ))}
                    </ul>
                    <div className='event-details-participants-edit'>
                        <a
                            href='#'
                            onClick={setIsEditMode}
                        >
                            View/Edit Participants
                        </a>
                    </div>
                </section>
                <Popup
                    title='Participants'
                    className='manage-participants-modal'
                    priority={1000}
                    active={isEditMode}
                    onClose={setIsEditMode}
                >
                    {isEditMode && (
                        <div className='event-participants-form'>
                            <input
                                type='text'
                                placeholder='Search participants...'
                                className='event-participants-form-filter'
                                onChange={setFilter}
                            />

                            <section>
                                <h4>Participants added</h4>

                                <ul>
                                    {participantsEventSettingsState.currentParticipantsList.map((participant) => {
                                        return <li key={participant.id}>{participant.name}</li>;
                                    })}
                                    {participantsEventSettingsState.addedParticipants.map((participant) => {
                                        return (
                                            <li key={`${participant.id}'-chosen'`}>
                                                {participant.name}
                                                <a
                                                    href='#'
                                                    onClick={(): void =>
                                                        participantsEventSettingsState.removeParticipant(participant)
                                                    }
                                                >
                                                    -
                                                </a>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </section>

                            <div className='event-participants-form-new'>
                                <input
                                    type='text'
                                    placeholder='Participant name'
                                    value={participantsEventSettingsState.newParticipantName}
                                    onChange={participantsEventSettingsState.setNewParticipantName}
                                />
                                <a
                                    href='#'
                                    className='btn'
                                    onClick={participantsEventSettingsState.createParticipant}
                                >
                                    Add new
                                </a>
                            </div>

                            <section>
                                <h4>Add additional participants below</h4>

                                <ul>
                                    {participantsEventSettingsState.availableParticipantsList.map((participant) => {
                                        return (
                                            <li key={`${participant.id}-available`}>
                                                {participant.name}
                                                <a
                                                    href='#'
                                                    onClick={(): void =>
                                                        participantsEventSettingsState.addParticipant(participant)
                                                    }
                                                >
                                                    +
                                                </a>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </section>

                            <div className='buttons'>
                                <a
                                    href='#'
                                    className='btn event-participants-form-save'
                                    onClick={participantsEventSettingsState.submitParticipantsChanges}
                                >
                                    Confirm selections
                                </a>
                            </div>
                        </div>
                    )}
                </Popup>
            </div>
        );
    }
);
